console.log("router-cache-bust.js loaded");
(function () {
    // Homepage cache may be reused this long after prefetch/navigate (keeps logo fast).
    var HOME_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

    // How long a tab must stay hidden before we clear the full SPA cache.
    var HIDDEN_MS = 24 * 60 * 60 * 1000; // 24 hours

    // Do not hit the network for a build check more often than this.
    var BUILD_CHECK_MIN_MS = 10 * 1000; // 10 seconds

    // Wait this long after navigation before build-check fetch (avoids competing
    // with the real Highway page request, e.g. going Home via #main-logo).
    var BUILD_CHECK_DELAY_MS = 750;

    // Periodic safety net: re-check the build every few minutes even if the
    // user never navigates, so idle-but-visible tabs pick up promo changes
    // (pencil bar) without any user action. Skipped while the tab is hidden.
    var PERIODIC_CHECK_MS = 5 * 60 * 1000; // 5 minutes

    var hiddenAt = null;
    var hooked = false;
    var buildChecking = false;
    var lastBuildCheck = 0;
    var buildCheckTimer = null;

    // url string -> timestamp when that homepage entry was stored in router.cache
    var homeCachedAt = {};

    // ---------------------------------------------------------------------------
    // isHomeUrl(url)
    // True for the site homepage (/, optional trailing slash / query).
    // ---------------------------------------------------------------------------
    function isHomeUrl(url) {
        if (!url) return false;

        try {
            var u = new URL(url, window.location.origin);
            if (u.origin !== window.location.origin) return false;
            var path = u.pathname.replace(/\/+$/, "") || "/";
            return path === "/";
        } catch (e) {
            return false;
        }
    }

    // ---------------------------------------------------------------------------
    // isHomeExpired(key)
    // True if this homepage cache entry is older than HOME_TTL_MS.
    // ---------------------------------------------------------------------------
    function isHomeExpired(key) {
        var cachedAt = homeCachedAt[key];
        if (!cachedAt) return true;
        return Date.now() - cachedAt > HOME_TTL_MS;
    }

    // ---------------------------------------------------------------------------
    // expireHomeIfNeeded(cache, key)
    // If a homepage entry is past TTL, delete it so Highway must refetch.
    // ---------------------------------------------------------------------------
    function expireHomeIfNeeded(cache, key) {
        if (!isHomeUrl(key) || !isHomeExpired(key)) return false;
        if (cache && typeof cache.delete === "function") {
            cache.delete(key);
        }
        delete homeCachedAt[key];
        return true;
    }

    // ---------------------------------------------------------------------------
    // wrapHomeCacheTtl(router)
    // Allows homepage to be cached (fast logo clicks after prefetch), but
    // cache.has / cache.get treat expired home entries as missing.
    // ---------------------------------------------------------------------------
    function wrapHomeCacheTtl(router) {
        var cache = router.cache;

        if (!cache || typeof cache.set !== "function" || cache.__ozarkeHomeBust) {
            return;
        }

        var originalSet = cache.set.bind(cache);
        var originalGet = cache.get.bind(cache);
        var originalHas = cache.has.bind(cache);
        var originalDelete = cache.delete.bind(cache);
        var originalClear = cache.clear && cache.clear.bind(cache);

        // Action: store pages normally; stamp homepage entries with a time.
        cache.set = function (key, value) {
            if (isHomeUrl(key)) {
                homeCachedAt[key] = Date.now();
            }
            return originalSet(key, value);
        };

        // Action: expired homepage => pretend it was never cached (force refetch).
        cache.get = function (key) {
            if (expireHomeIfNeeded(cache, key)) return undefined;
            return originalGet(key);
        };

        // Action: same TTL rule for has() — Highway checks has() before get().
        cache.has = function (key) {
            if (expireHomeIfNeeded(cache, key)) return false;
            return originalHas(key);
        };

        cache.delete = function (key) {
            if (isHomeUrl(key)) delete homeCachedAt[key];
            return originalDelete(key);
        };

        if (originalClear) {
            cache.clear = function () {
                homeCachedAt = {};
                return originalClear();
            };
        }

        cache.__ozarkeHomeBust = true;
    }

    // ---------------------------------------------------------------------------
    // parseBuildFromHtml(html)
    // Reads <meta name="oz-theme-build"> from a live HTML response.
    // ---------------------------------------------------------------------------
    function parseBuildFromHtml(html) {
        if (!html) return null;

        var match = html.match(/name=["']oz-theme-build["']\s+content=["']([^"']+)["']/i) || html.match(/content=["']([^"']+)["']\s+name=["']oz-theme-build["']/i);

        return match ? match[1] : null;
    }

    // ---------------------------------------------------------------------------
    // clearRouterCache()
    // Empties Highway's entire in-memory page Map.
    // ---------------------------------------------------------------------------
    function clearRouterCache() {
        if (window.router && window.router.cache && typeof window.router.cache.clear === "function") {
            window.router.cache.clear();
        }
        homeCachedAt = {};
    }

    // ---------------------------------------------------------------------------
    // checkThemeBuild()
    // Fetch current URL (no-store), compare oz-theme-build to this tab's boot
    // build, reload if the theme assets changed.
    // ---------------------------------------------------------------------------
    function checkThemeBuild() {
        var localBuild = window.__OZ_THEME_BUILD__;
        if (!localBuild || buildChecking) return;

        var now = Date.now();
        if (now - lastBuildCheck < BUILD_CHECK_MIN_MS) return;
        lastBuildCheck = now;
        buildChecking = true;

        var url = window.location.pathname + window.location.search;
        if (!url || url.charAt(0) !== "/") {
            url = "/";
        }

        fetch(url, {
            method: "GET",
            credentials: "same-origin",
            cache: "no-store",
            headers: { "X-Requested-With": "Highway" },
        })
            .then(function (res) {
                return res.text();
            })
            .then(function (html) {
                buildChecking = false;
                var remoteBuild = parseBuildFromHtml(html);

                if (remoteBuild && remoteBuild !== localBuild) {
                    clearRouterCache();
                    window.location.reload();
                }
            })
            .catch(function () {
                buildChecking = false;
            });
    }

    // ---------------------------------------------------------------------------
    // scheduleBuildCheck()
    // Run build detection AFTER navigation settles so it does not slow #main-logo.
    // ---------------------------------------------------------------------------
    function scheduleBuildCheck() {
        if (buildCheckTimer) clearTimeout(buildCheckTimer);
        buildCheckTimer = setTimeout(function () {
            buildCheckTimer = null;
            checkThemeBuild();
        }, BUILD_CHECK_DELAY_MS);
    }

    // ---------------------------------------------------------------------------
    // hookRouter(router)
    // Attach TTL wrapping and deferred build checks to Highway.
    // ---------------------------------------------------------------------------
    function hookRouter(router) {
        if (!router || !router.cache || hooked) return false;

        wrapHomeCacheTtl(router);

        if (typeof router.on === "function") {
            // After SPA navigation finishes (not while Home is still loading):
            router.on("NAVIGATE_END", function () {
                scheduleBuildCheck();
            });

            // Fallback if NAVIGATE_END is unavailable in this Highway build:
            router.on("NAVIGATE_IN", function () {
                scheduleBuildCheck();
            });
        }

        hooked = true;
        return true;
    }

    // ---------------------------------------------------------------------------
    // tryHook()
    // Wait briefly for window.router (main.js is deferred).
    // ---------------------------------------------------------------------------
    function tryHook() {
        if (window.router && hookRouter(window.router)) {
            // Heal long-lived tabs even if the user never navigates (pencil bar
            // lives outside the SPA router and only updates on full reload).
            scheduleBuildCheck();
            return;
        }

        var attempts = 0;
        var id = setInterval(function () {
            attempts += 1;
            if (window.router && hookRouter(window.router)) {
                clearInterval(id);
                scheduleBuildCheck();
            } else if (attempts > 40) {
                clearInterval(id);
                // Still run build check without the router — reload path only needs
                // __OZ_THEME_BUILD__ vs live meta (pencil-bar / asset changes).
                scheduleBuildCheck();
            }
        }, 50);
    }

    // ---------------------------------------------------------------------------
    // Periodic build check
    // Idle-but-visible tabs (user reading / tab left open on screen) never fire
    // NAVIGATE_* or visibilitychange, so poll every PERIODIC_CHECK_MS. The tab
    // reloads itself when a new build (asset deploy or pencil-bar promo change)
    // is detected — no user action needed. Throttle in checkThemeBuild() still
    // caps network use.
    // ---------------------------------------------------------------------------
    setInterval(function () {
        if (document.visibilityState === "visible") {
            checkThemeBuild();
        }
    }, PERIODIC_CHECK_MS);

    // ---------------------------------------------------------------------------
    // visibilitychange
    // Long-idle tabs: clear SPA cache + check for a new theme build.
    // ---------------------------------------------------------------------------
    document.addEventListener("visibilitychange", function () {
        if (document.visibilityState === "hidden") {
            hiddenAt = Date.now();
            return;
        }

        if (document.visibilityState !== "visible" || hiddenAt == null) return;

        var elapsed = Date.now() - hiddenAt;
        hiddenAt = null;

        // Full SPA cache flush only after a long hide (24h) — keeps nav fast.
        if (elapsed >= HIDDEN_MS) {
            clearRouterCache();
        }

        // Build check on every return to the tab (cheap; throttled to 10s).
        // Catches promo/asset changes made while the user was away.
        checkThemeBuild();
    });

    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", tryHook);
    } else {
        tryHook();
    }
})();
